// File: src/App.js - Remove age verification and make About the default page

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import axios from 'axios';
import styled from 'styled-components'; 
import Login from './Login';
import Register from './Register';
import Create from './pages/Create';
import PublicGallery from './pages/PublicGallery';
import PrivateGallery from './pages/PrivateGallery';
// import AgeVerification from "./components/AgeVerification"; // REMOVE THIS
import PublicProfile from './pages/PublicProfile';
import PublicAgentProfile from './pages/PublicAgentProfile';
import AdminPanel from './pages/AdminPanel';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Pricing from './pages/Pricing';
import Footer from './components/Footer';
import ShowingBooker from './pages/ShowingBooker';
import ShowingBookerLanding from './pages/ShowingBookerLanding';
import AgentProfile from './pages/showingbooker/components/AgentProfile';
import StartPage from './pages/showingbooker/components/StartPage';
import CRMPage from './pages/showingbooker/components/CRMPage';
import About from './pages/About';
// New redesigned pages
import PublicShowcase from './pages/PublicShowcase';
import Agents from './pages/Agents';
import TenantFAQ from './pages/TenantFAQ';
import TenantRights from './pages/TenantRights';
import OwnerProtection from './pages/OwnerProtection';
import AgentLiability from './pages/AgentLiability';
import TenantFAQTest from './pages/TenantFAQTest';
import Logo from './components/Logo';
import BookingPage from './pages/showingbooker/components/BookingPage';
import DemoBookingPage from './pages/showingbooker/components/DemoBookingPage';
import SharedPropertyPage from './pages/showingbooker/components/SharedPropertyPage';
import PropertyUnavailable from './pages/PropertyUnavailable';
import PasswordProtection, { hasAppAccess } from './components/PasswordProtection';


// Import new account components
import AccountLayout from './components/AccountLayout';
import AccountProfile from './pages/account/AccountProfile';
import Settings from './pages/account/Settings';
// Hidden billing/credits components (uncomment to re-enable)
// import Billing from './pages/account/Billing';
// import Credits from './pages/account/Credits';
import Oracle from './pages/account/Oracle';

// Styled Components
const AppContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  
  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #eee;
  
  @media (max-width: 768px) {
    padding: 0.75rem 0;
    flex-wrap: wrap;
    gap: 1rem;
  }
`;

const BookingMenu = styled.nav`
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem 0;
  
  .booking-nav {
    display: flex;
    align-items: center;
    gap: 1rem;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    
    /* Mobile responsive */
    @media (max-width: 768px) {
      gap: 0.5rem;
      padding: 0 10px;
      justify-content: flex-start;
    }
  }
  
  .booking-nav a {
    text-decoration: none;
    color: #666;
    font-weight: 500;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    white-space: nowrap;
    flex-shrink: 0;
    
    /* Mobile optimizations */
    @media (max-width: 768px) {
      padding: 0.4rem 0.75rem;
      font-size: 0.875rem;
    }
    
    @media (max-width: 480px) {
      padding: 0.35rem 0.6rem;
      font-size: 0.8rem;
    }
    
    &.active {
      color: #000;
      background: white;
      box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    }
    
    &:hover {
      color: #000;
      background: white;
    }
  }
`;

const UserInfo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const UserMenuButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: 1px solid #ddd;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  color: #333;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f8f9fa;
    border-color: #adb5bd;
  }
`;

const UserDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  min-width: 200px;
  z-index: 1000;
  margin-top: 4px;
  
  .dropdown-item {
    display: block;
    width: 100%;
    padding: 0.75rem 1rem;
    border: none;
    background: none;
    text-align: left;
    cursor: pointer;
    color: #333;
    text-decoration: none;
    transition: background 0.2s ease;
    
    &:hover {
      background: #f8f9fa;
    }
    
    &.username {
      border-bottom: 1px solid #eee;
      font-weight: 600;
      cursor: default;
      
      &:hover {
        background: none;
      }
    }
    
    &.signout {
      color: #dc3545;
      border-top: 1px solid #eee;
      
      &:hover {
        background: #f8d7da;
      }
    }
  }
`;

const LogoLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none !important;
  
  &:hover {
    opacity: 0.8;
  }
`;

const LogoText = styled.span`
  font-size: 1.25rem;
  color: #333;
  
  .brand-main {
    font-weight: 900;
  }
  
  .brand-by {
    font-weight: 300;
    color: #666;
  }
`;

const PublicNav = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  
  @media (max-width: 768px) {
    gap: 0.5rem;
  }
  
  @media (max-width: 480px) {
    gap: 0.25rem;
  }
  
  a {
    text-decoration: none;
    color: #333;
    font-weight: 500;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    transition: all 0.2s ease;
    white-space: nowrap;
    
    @media (max-width: 768px) {
      padding: 0.4rem 0.75rem;
      font-size: 0.875rem;
    }
    
    @media (max-width: 480px) {
      padding: 0.35rem 0.6rem;
      font-size: 0.8rem;
    }
    
    &:hover {
      color: #007bff;
    }
    
    &.get-started {
      background: #667eea;
      color: white;
      
      &:hover {
        background: #5a67d8;
      }
    }
  }
`;

// BookingMenu Component - appears only on ShowingBooker pages
const BookingMenuComponent = ({ user }) => {
  const location = useLocation();
  
  // Show sub-navigation for all logged-in users except on public pages
  const isPublicPage = location.pathname.startsWith('/book/') || 
                      location.pathname.startsWith('/demo-booking') ||
                      location.pathname.startsWith('/property/share/') ||
                      location.pathname.includes('/login') ||
                      location.pathname.includes('/register') ||
                      location.pathname === '/' ||
                      location.pathname === '/about' ||
                      location.pathname === '/how' ||
                      location.pathname === '/pricing' ||
                      location.pathname === '/contact';
  
  // Hide sub-nav if user is not logged in or on public pages
  if (!user || isPublicPage) return null;
  
  return (
    <BookingMenu>
      <div className="booking-nav">
        <NavLink 
          to="/start" 
          className={location.pathname === '/start' ? 'active' : ''}
        >
          Start
        </NavLink>
        <NavLink 
          to="/overview" 
          className={location.pathname === '/overview' ? 'active' : ''}
        >
          Overview
        </NavLink>
        <NavLink 
          to="/listings" 
          className={location.pathname === '/listings' ? 'active' : ''}
        >
          Listings
        </NavLink>
        <NavLink 
          to="/crm" 
          className={location.pathname === '/crm' ? 'active' : ''}
        >
          CRM
        </NavLink>
        <NavLink 
          to="/upcoming" 
          className={location.pathname === '/upcoming' ? 'active' : ''}
        >
          Showings
        </NavLink>
        <NavLink 
          to="/calendar" 
          className={location.pathname === '/calendar' ? 'active' : ''}
        >
          Calendar
        </NavLink>
      </div>
    </BookingMenu>
  );
};

const AppContent = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  // const [isVerified, setIsVerified] = useState(false); // REMOVE THIS
  const [userProfile, setUserProfile] = useState(null);
  const [error, setError] = useState(null);
  const [passwordPrompt, setPasswordPrompt] = useState(null);
  const [showUserDropdown, setShowUserDropdown] = useState(false);

  useEffect(() => {
    // REMOVE AGE VERIFICATION CHECK
    // const verified = localStorage.getItem("ageVerified");
    // if (verified === "true") {
    //   setIsVerified(true);
    // }

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      try {
        console.log('Auth State Changed:', user ? 'User logged in' : 'No user');
        setUser(user);
        
        if (user) {
          // Store user info for authentication checks
          const token = await user.getIdToken();
          localStorage.setItem('userToken', token);
          localStorage.setItem('userId', user.uid);
          await fetchUserProfile(user);
        } else {
          setUserProfile(null);
          localStorage.removeItem('userToken');
          localStorage.removeItem('userId');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const fetchUserProfile = async (user) => {
    if (!user) return;
    try {
      const token = await user.getIdToken();
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/user-profile/${user.uid}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setUserProfile(response.data);
    } catch (error) {
      console.error("Error fetching user profile:", error);
      
      // Check if it's a 404 error (user not found)
      if (error.response && error.response.status === 404) {
        try {
          // User doesn't exist in the database, create a new user
          console.log("Creating new user profile...");
          const token = await user.getIdToken();
          const createResponse = await axios.post(
            `${process.env.REACT_APP_API_URL}/create-user`, 
            {
              uid: user.uid,
              email: user.email,
              username: user.email.split('@')[0] // Default username from email
            },
            {
              headers: { 'Authorization': `Bearer ${token}` }
            }
          );
          
          setUserProfile(createResponse.data);
        } catch (createError) {
          console.error("Error creating user profile:", createError);
          setError("Failed to create user profile");
        }
      } else {
        setError("Failed to load user profile");
      }
    }
  };

  const handleLoginSuccess = async (user) => {
    try {
      setUser(user);
      // Get fresh token and store it (though API will use Firebase directly)
      const token = await user.getIdToken();
      localStorage.setItem('userToken', token);
      localStorage.setItem('userId', user.uid);
      await fetchUserProfile(user);
    } catch (error) {
      setError("Login failed: " + error.message);
    }
  };

  const handleSignOut = async () => {
    try {
      await auth.signOut();
      setUser(null);
      setUserProfile(null);
      localStorage.removeItem('userToken');
      localStorage.removeItem('userId');
      // Clear app access on logout
      sessionStorage.removeItem('dreamhotties_access');
      sessionStorage.removeItem('oracle_access');
    } catch (error) {
      setError("Sign out failed: " + error.message);
    }
  };

  // Handle protected app access
  const handleProtectedAppClick = (appKey, targetPath) => {
    // Validate target path to prevent redirect injection
    const allowedPaths = ['/oracle', '/create', '/private-gallery'];
    if (!allowedPaths.includes(targetPath)) {
      console.error('Invalid target path:', targetPath);
      return;
    }
    
    if (hasAppAccess(appKey)) {
      navigate(targetPath);
    } else {
      setPasswordPrompt({ appKey, targetPath });
    }
  };

  const handlePasswordSuccess = () => {
    if (passwordPrompt) {
      // Validate target path to prevent redirect injection
      const allowedPaths = ['/oracle', '/create', '/private-gallery'];
      if (allowedPaths.includes(passwordPrompt.targetPath)) {
        navigate(passwordPrompt.targetPath);
      }
      setPasswordPrompt(null);
    }
  };

  const handlePasswordCancel = () => {
    setPasswordPrompt(null);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showUserDropdown && !event.target.closest('.user-info')) {
        setShowUserDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserDropdown]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <HelmetProvider>
      <>
        {/* REMOVE AGE VERIFICATION WRAPPER */}
        <AppContainer>
        {/* Show different headers based on authentication status */}
        {user ? (
          <Header>
            <LogoLink to="/">
              <Logo size="40px" showText={false} color="#333" />
              <LogoText>
                <span className="brand-main">ShowingBooker.com</span>
              </LogoText>
            </LogoLink>
            
            {/* Main Menu (Public Links + Properties for logged in users) */}
            <PublicNav>
              <NavLink to="/">Public</NavLink>
              <NavLink to="/agents">Agents</NavLink>
              <NavLink to="/pricing">Pricing</NavLink>
              <NavLink to="/about">About</NavLink>
              <NavLink to="/showingbooker/overview">Dashboard</NavLink>
            </PublicNav>
            
            {/* User Menu */}
            <UserInfo className="user-info">
              <UserMenuButton onClick={() => setShowUserDropdown(!showUserDropdown)}>
                {userProfile?.anonymous_username || user.email}
                <span>{showUserDropdown ? '▲' : '▼'}</span>
              </UserMenuButton>
              {showUserDropdown && (
                <UserDropdown>
                  <div className="dropdown-item username">
                    {userProfile?.anonymous_username || user.email}
                  </div>
                  <NavLink to="/account" className="dropdown-item" onClick={() => setShowUserDropdown(false)}>
                    Account
                  </NavLink>
                  <NavLink to="/account/settings" className="dropdown-item" onClick={() => setShowUserDropdown(false)}>
                    Settings
                  </NavLink>
                  <NavLink to="/profile" className="dropdown-item" onClick={() => setShowUserDropdown(false)}>
                    Agent Profile
                  </NavLink>
                  <NavLink to="/stats" className="dropdown-item" onClick={() => setShowUserDropdown(false)}>
                    Stats
                  </NavLink>
                  <NavLink to="/support" className="dropdown-item" onClick={() => setShowUserDropdown(false)}>
                    Support
                  </NavLink>
                  <NavLink to="/completed" className="dropdown-item" onClick={() => setShowUserDropdown(false)}>
                    Completed Showings
                  </NavLink>
                  <button className="dropdown-item signout" onClick={handleSignOut}>
                    Sign out
                  </button>
                </UserDropdown>
              )}
            </UserInfo>
          </Header>
        ) : (
          /* Header for non-authenticated users */
          <Header>
            <LogoLink to="/">
              <Logo size="40px" showText={false} color="#333" />
              <LogoText>
                <span className="brand-main">ShowingBooker</span>
              </LogoText>
            </LogoLink>
            <PublicNav>
              <NavLink to="/">Public</NavLink>
              <NavLink to="/agents">Agents</NavLink>
              <NavLink to="/pricing">Pricing</NavLink>
              <NavLink to="/about">About</NavLink>
              <NavLink to="/login">Sign In</NavLink>
              <NavLink to="/register" className="get-started">Get Started</NavLink>
            </PublicNav>
          </Header>
        )}

        {/* Show Booking Menu for authenticated users on ShowingBooker pages */}
        {user && <BookingMenuComponent user={user} />}

        <Routes>
          {/* New Public showcase page (replaces Home) */}
          <Route path="/" element={<PublicShowcase user={user} />} />
          
          {/* New Agents page (replaces Reviews) */}
          <Route path="/agents" element={<Agents user={user} />} />
          
          {/* Updated Pricing page */}
          <Route path="/pricing" element={<Pricing user={user} />} />
          
          {/* Updated About page (replaces Contact) */}
          <Route path="/about" element={<About user={user} onProtectedAppClick={handleProtectedAppClick} />} />
          
          {/* Legacy routes for SEO - redirect to new structure */}
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/how" element={<Navigate to="/agents" replace />} />
          <Route path="/reviews" element={<Navigate to="/agents" replace />} />
          <Route path="/contact" element={<Navigate to="/about" replace />} />
          
          {/* Specialized content pages */}
          <Route path="/tenant-faq" element={<TenantFAQ />} />
          <Route path="/tenant-rights" element={<TenantRights />} />
          <Route path="/owner-protection" element={<OwnerProtection />} />
          <Route path="/agent-liability" element={<AgentLiability />} />
          <Route path="/tenant-faq-test" element={<TenantFAQTest />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/public-gallery" element={<PublicGallery />} />
          <Route path="/profile/:username" element={<PublicProfile />} />
          <Route path="/agent/:username" element={<PublicAgentProfile />} />
          
          {/* Public ShowingBooker booking page */}
          <Route path="/book/:propertyId" element={<BookingPage />} />
          <Route path="/demo-booking" element={<DemoBookingPage />} />
          <Route path="/property/share/:propertySlug" element={<SharedPropertyPage />} />
          <Route path="/property-unavailable/:propertyId" element={<PropertyUnavailable />} />
          
          {/* Authentication routes */}
          <Route 
            path="/login" 
            element={
              user ? <Navigate to="/start" /> : <Login onLoginSuccess={handleLoginSuccess} />
            } 
          />
          <Route 
            path="/register" 
            element={
              user ? <Navigate to="/start" /> : <Register />
            } 
          />

          {/* ShowingBooker routes */}
          <Route path="/showingbooker" element={<ShowingBookerLanding />} />
          <Route 
            path="/start" 
            element={
              user ? <StartPage /> : <Navigate to="/login" />
            }
          />
          <Route 
            path="/overview" 
            element={
              user ? <ShowingBooker /> : <Navigate to="/login" />
            }
          />
          <Route 
            path="/listings" 
            element={
              user ? <ShowingBooker /> : <Navigate to="/login" />
            }
          />
          <Route 
            path="/owners" 
            element={
              user ? <ShowingBooker /> : <Navigate to="/login" />
            }
          />
          <Route 
            path="/residents" 
            element={
              user ? <ShowingBooker /> : <Navigate to="/login" />
            }
          />
          <Route 
            path="/buyers" 
            element={
              user ? <ShowingBooker /> : <Navigate to="/login" />
            }
          />
          <Route 
            path="/crm" 
            element={
              user ? <CRMPage /> : <Navigate to="/login" />
            }
          />
          {/* Legacy route redirects */}
          <Route path="/showingbooker/overview" element={<Navigate to="/overview" replace />} />
          <Route path="/showingbooker/add" element={<Navigate to="/listings/add" replace />} />
          <Route path="/showingbooker/properties" element={<Navigate to="/listings" replace />} />
          <Route path="/showingbooker/calendar" element={<Navigate to="/calendar" replace />} />
          <Route path="/showingbooker/upcoming" element={<Navigate to="/upcoming" replace />} />
          <Route path="/showingbooker/completed" element={<Navigate to="/completed" replace />} />
          <Route path="/showingbooker/stats" element={<Navigate to="/stats" replace />} />
          <Route path="/showingbooker/rd" element={<Navigate to="/support" replace />} />
          <Route path="/rd" element={<Navigate to="/support" replace />} />
          <Route path="/showingbooker/profile" element={<Navigate to="/profile" replace />} />
          <Route path="/account/showing-profile" element={<Navigate to="/profile" replace />} />
          <Route path="/account/profile" element={<Navigate to="/account" replace />} />
          <Route path="/showingbooker/dashboard" element={<Navigate to="/listings" replace />} />
          <Route path="/showingbooker/listings" element={<Navigate to="/listings" replace />} />
          <Route path="/prospects" element={<Navigate to="/crm" replace />} />
          <Route path="/properties" element={<Navigate to="/listings" replace />} />
          <Route path="/owners" element={<Navigate to="/crm" replace />} />
          <Route path="/buyers" element={<Navigate to="/crm" replace />} />
          <Route path="/residents" element={<Navigate to="/crm" replace />} />
          <Route 
            path="/calendar" 
            element={
              user ? <ShowingBooker /> : <Navigate to="/login" />
            }
          />
          <Route 
            path="/upcoming" 
            element={
              user ? <ShowingBooker /> : <Navigate to="/login" />
            }
          />
          <Route 
            path="/completed" 
            element={
              user ? <ShowingBooker /> : <Navigate to="/login" />
            }
          />
          <Route 
            path="/stats" 
            element={
              user ? <ShowingBooker /> : <Navigate to="/login" />
            }
          />
          <Route 
            path="/support" 
            element={
              user ? <ShowingBooker /> : <Navigate to="/login" />
            }
          />
          <Route 
            path="/profile" 
            element={
              user ? <AgentProfile user={user} userProfile={userProfile} /> : <Navigate to="/login" />
            }
          />
          
          {/* Protected app routes with password protection */}
          <Route 
            path="/oracle" 
            element={
              user ? (
                hasAppAccess('oracle') ? (
                  <Oracle user={user} userProfile={userProfile} />
                ) : (
                  <Navigate to="/start" />
                )
              ) : (
                <Navigate to="/login" />
              )
            } 
          />
          <Route 
            path="/create" 
            element={
              user ? (
                hasAppAccess('dreamhotties') ? (
                  <Create user={user} />
                ) : (
                  <Navigate to="/about" />
                )
              ) : (
                <Navigate to="/login" />
              )
            } 
          />
          <Route 
            path="/private-gallery" 
            element={
              user ? <PrivateGallery user={user} /> : <Navigate to="/login" />
            } 
          />
          
          {/* Account routes */}
          <Route 
            path="/account/*" 
            element={
              user ? (
                <AccountLayout>
                  <Routes>
                    <Route path="/" element={<AccountProfile user={user} userProfile={userProfile} />} />
                    <Route path="/profile" element={<AccountProfile user={user} userProfile={userProfile} />} />
                    {/* Legacy route redirect */}
                    <Route path="/showing" element={<Navigate to="/account/showing-profile" replace />} />
                    <Route path="/settings" element={<Settings user={user} userProfile={userProfile} />} />
                    {/* Hidden billing/credits routes (uncomment to re-enable) */}
                    {/* <Route path="/billing" element={<Billing user={user} userProfile={userProfile} />} /> */}
                    {/* <Route path="/credits" element={<Credits user={user} userProfile={userProfile} />} /> */}
                  </Routes>
                </AccountLayout>
              ) : <Navigate to="/login" />
            } 
          />
          
          {/* Admin route */}
          <Route 
            path="/admin" 
            element={
              user ? <AdminPanel user={user} /> : <Navigate to="/login" />
            } 
          />

        </Routes>

        <Footer user={user} />
      </AppContainer>
      
      {/* Password protection modal */}
      {passwordPrompt && (
        <PasswordProtection
          appKey={passwordPrompt.appKey}
          onSuccess={handlePasswordSuccess}
          onCancel={handlePasswordCancel}
        />
      )}
      </>
    </HelmetProvider>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;